import React from 'react';
import PortalCommunication from '@helpers/portal-comms';

const showConnectionError = () => {
  const message = `${'Oops an error has occurred. '}
  ${(<a href="http://www.3plearning.com/contact/">Please contact Tech Support</a>)}
  ${' with details of what happened and we will work to get you back on track.'}`;
  PortalCommunication.serverError(message);
};

export default showConnectionError;
